import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "返回顶部", -1)
const _hoisted_2 = [
  _hoisted_1
]




export default /*#__PURE__*/_defineComponent({
  __name: 'ToTop',
  props: {
    show: {
        type: Boolean,
        default: false,
    },
},
  emits: ["toTop"],
  setup(__props, { emit: __emit }) {

const emits = __emit;


function toTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    emits("toTop");
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "to-top",
    onClick: toTop
  }, _hoisted_2, 512)), [
    [_vShow, __props.show]
  ])
}
}

})